export const MAX_TAGLINE_LENGTH = 70;

export enum DataHooks {
  ROOT = 'tag-line-root',
  TEXT = 'tag-line-text',
}
